import MonetaryCompensation from '@/views/MonetaryCompensation/index.vue'

const MonetaryCompensationRouter = {
  path: '/monetary-compensation',
  name: 'MonetaryCompensation',
  component: MonetaryCompensation,
  props: (route) => ({
    secret: route.query.secret,
    monetaryId: route.query.monetary_id,
    orderId: route.query.order_id || null
  })
}

export default MonetaryCompensationRouter
